
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0172c9e9\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../../vue-loader/lib/selector?type=styles&index=0!./flatButton.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./flatButton.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0172c9e9\"}!../../../vue-loader/lib/selector?type=template&index=0!./flatButton.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/flatButton/flatButton.vue
// module id = 360
// module chunks = 1